<script>
    export default {
        name: "genericElementTileContainer",
        props: {
            id: {}, // String or Number
            small: Boolean,
            colClass: String,
            cardClass: Array,
            entityName: String,
        },
        computed: {
            cols: function () {
                if (this.colClass === 'two-in-a-row') {
                    return 6;
                } else if (this.colClass === 'three-in-a-row') {
                    return 4;
                } else if (this.colClass === 'four-in-a-row') {
                    return 3;
                } else if (this.colClass === 'five-in-a-row') {
                    return 2;
                } else {
                    return 12;
                }
            }
        },
    }
</script>

<template>
    <v-col
        :key="id"
        :cols="small ? cols : 2"
        :class="colClass"
    >
        <v-card
            :flat="small"
            :key="id"
            :id="`${entityName}-card-${id}`"
            :class="cardClass"
        >
            <slot/>
        </v-card>
    </v-col>
</template>
